import { Action } from "./Action.js";
import { toBool, getElementByIdInContext } from "../lib/utils.js";
/**
 * @class OpenUrl
 * @extends Action
 * @classdesc Действие Открыть адрес
 * Открыть любой адрес
 * */
export class OpenUrl extends Action {
    execute() {
        const isWindowId = /^\d+($|\?)/.test(this.Address);

        let address = this.Address;
        if (this.parameters) {
            address = this.addParameters(address, isWindowId);
        }

        let finalAddress = address;

        if (this.AddSessionId) {
            const delimiter = (isWindowId || finalAddress.indexOf("?") !== -1) ? "&" : "?";
            finalAddress = `${finalAddress}${delimiter}session_id=${$sw.sessionId}`;
        }

        const windowOpenUrl = isWindowId ? `?${finalAddress}` : finalAddress;

        if (this._openNew === true) {
            window.open(windowOpenUrl);
        } else {
            if (this._FrameID) {
                // поскольку на странице могут быть несколько экземпляторов объектов,
                // то у них будут одинаковые id, поэтому нужно искать нужный объект внутри текущего контекста:
                const frame = this.FrameID
                    ? getElementByIdInContext(this.context, this.FrameID)
                    : document.querySelector("ms-frame");
                const isExternalAddress = address.indexOf('//') !== -1;
                if ($sw.serverState.haveReserv && !isExternalAddress && address && !isWindowId) {
                    frame.datasource = `${window.location.protocol}//${$sw.serverState.location.hostname}:${$sw.serverState.location.port}/${finalAddress}`;
                } else {
                    frame.datasource = isWindowId ? this.Address : finalAddress;
                }
            } else {
                window.open(windowOpenUrl, "_self");
            }
        }
    }

    addParameters(address, isWindowId) {
        let initialAddress = address;

        if (isWindowId) {
            if (address.indexOf("?") === -1 && address.indexOf("&") === -1) {
                initialAddress = `${address}&`;
            }
        } else {
            if (address.indexOf("?") === -1) {
                initialAddress = `${address}?`;
            }
        }

        return Object.entries(this.parameters) // todo: сюда должны приходить параметры TargetName и Source, а всё остальное нужно убирать!
            .sort() // нужно сгруппировать по именам, поскольку ключ-значение могут приходить в разном порядке, т.е. в перемешку
            .map((x, i, arr) => (i % 2 === 0 ? arr[i + 1] : arr[i - 1])) // нужно, чтобы сначала шёл TargetName, а затем Source
            .reduce((acc, [, next]) => {
                switch (acc.slice(-1)) {
                    case "?":
                    case "&": {
                        return `${acc}${next}=`;
                    }
                    case "=": {
                        return `${acc}${next}`;
                    }
                    default: {
                        return `${acc}&${next}=`;
                    }
                }
            }, initialAddress);
    }

    get Address() {
        return this._address || "";
    }
    set Address(v) {
        this._address = v;
    }

    get OpenNew() {
        return typeof this._openNew === "boolean" ? this._openNew : false;
    }
    set OpenNew(v) {
        this._openNew = toBool(v);
    }

    get AddSessionId() {
        return this._addSessionId;
    }
    set AddSessionId(v) {
        this._addSessionId = v;
    }

    get FrameID() {
        return typeof this._FrameID === "undefined" ? "" : this._FrameID;
    }
    set FrameID(value) {
        if (value.toString().includes(".")) {
            this._FrameID = $pr.getWindowIdByPath(value);
        } else {
            this._FrameID = value;
        }
    }
}
